import EventEmitter from 'eventemitter3';
import {NavigateOptions, To} from 'react-router-dom';

const HistoryEvents = new EventEmitter<{
    navigate: (to: To | number, opts?: NavigateOptions) => void;
}>();

export default HistoryEvents;
